import { render, staticRenderFns } from "./edit_branch.vue?vue&type=template&id=312a814a&scoped=true"
import script from "./edit_branch.vue?vue&type=script&lang=js"
export * from "./edit_branch.vue?vue&type=script&lang=js"
import style0 from "./edit_branch.vue?vue&type=style&index=0&id=312a814a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a814a",
  null
  
)

export default component.exports